import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompany from '../_reducers/company';

export const selectCompanyState = createFeatureSelector<fromCompany.CompanyState>('companies');

export const selectAllCompanies = createSelector(selectCompanyState, fromCompany.selectAll);

export const selectCompanyEntities = createSelector(selectCompanyState, fromCompany.selectEntities);

export const selectCompanyById = (id: number) =>
  createSelector(selectCompanyEntities, (entities) => entities[id]);

export const selectCompanyTotal = createSelector(selectCompanyState, fromCompany.selectTotal);
